const regex = /\(\d{2}\) \d{8,9}$/;

const phoneValidator = {
  getMessage: field => 'Telefone inválido',
  validate: value => regex.test(value)
};

export default phoneValidator;
